import request from "@/utils/request";
const baseUrl = process.env.VUE_APP_APP_API + "/web/statistics";
// 统计数据
const statisticsApi = {
  getNewest() {
    return request({
      url: `${baseUrl}/getNewest`,
      method: "GET"
    });
  }
};
export default statisticsApi;
